import styled from 'styled-components';

export const ShowCaseTopSec = styled.section`
    width: 100%;
    @media screen and (max-width: 1024px){
        padding-top: 130px;
    }

    @media screen and (max-width: 767px){
        padding-top: 128px;
    }

    .row {
        align-items: center;
    }
    .search-header{
        display:none;
    }
    p {
        padding-bottom: 25px;
        &:last-child{
            padding-bottom: 0px;
        }
    }

    .showcase-reviews-banner{
        @media screen and (max-width: 1024px){
            padding: 60px 0px 50px;
        }
    }

    .left_banner{
        @media screen and (max-width: 1024px){
            margin-bottom: 0;
        }
    }   
`;

export const GainMoreExposureSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding: 50px;

    @media screen and (max-width: 767px){
        padding: 40px;
    }

    @media screen and (max-width: 480px){
        padding: 40px 15px;
    }
    
    .gainMore-exposure-main{
        background: #FFFFFF;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 10px 0px 10px 10px;
        border-radius: 20px;
        box-shadow: 0px 20px 20px #0000001A;
        
        @media screen and (max-width: 991px){
            row-gap: 30px;
            padding: 30px 20px;
            margin: 0;
        }

        @media screen and (max-width: 767px){
            padding: 30px 10px;
            border-radius: 15px;
        }
    }
`;

export const GainMoreExposureWrap = styled.div`
    width: 100%;
    padding-left: 5px;
    @media screen and (max-width: 991px){
        padding-left: 0px;
    }
`;

export const GainMoreExposureSlider = styled.div`
    width: 100%;
    margin: 0px auto;
    border: 8px solid #F3F3F3;
    border-radius: 20px;
    overflow: hidden;
    text-align: center;
    position: relative;

    .swiper-slide{
        position: relative;
        &::before{
            content: '';
            position: absolute;
            width: 100%;
            height: 112px;
            background: transparent linear-gradient(90deg, #FFFFFF00 0%, #FFFFFFD7 39%, #FFFFFFFA 56%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 2;
        }
    }
`;

export const GainMoreExposureTitle = styled.h2`
    max-width: 364px;
    color:#333333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 44px;
    margin-bottom: 20px;

    @media screen and (max-width: 991px){ 
        max-width: 100%;
        font-size: 28px;
        line-height: 40px;
    }
    
    @media screen and (max-width: 767px){ 
        font-size: 26px;
        line-height: 36px;
    }

    @media screen and (max-width: 480px){ 
        font-size: 22px;
        line-height: 32px;
        margin-bottom: 15px;
    }
`;

export const GainMoreExposureContent = styled.div`
    width: 100%;
    max-width: 500px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 28px;

    @media screen and (max-width: 991px){
        max-width: 100%;
    }
    @media screen and (max-width: 575px){
        font-size: 16px;
        line-height: 26px;
    }

`;

export const GainMoreExposureText = styled.p`
    padding-bottom: 20px;
    margin-bottom: 0;

    @media screen and (max-width: 767px){
        padding-bottom: 15px;
    }

    &:last-child{
        padding-bottom: 0px;  
    }
`;

export const SwiperSlider = styled.div`
    width: 100%;
    margin: 0px auto;
    overflow: hidden;
    text-align: center;
    
    .swiper{
        margin-top: 0px;
    }

    .swiper-pagination.swiper-pagination-bullets-dynamic.swiper-pagination-bullets.swiper-pagination-horizontal {
        display: flex;
        justify-content: center;
        align-items: center;
        bottom: 18px;
        z-index: 99;
    }

    span.swiper-pagination-bullet.swiper-pagination-bullet-active.swiper-pagination-bullet-active-main {
        background: #33A7AE;
        width: 16px;
        height: 16px;
    }

    span.swiper-pagination-bullet.swiper-pagination-bullet-active-next {
        width: 10px;
        height: 10px;
        background: #89DCE1;
    }
`;

export const SliderItem = styled.div``;


export const SliderItemImage = styled.div`
    width: 100%;
    max-width: 408px
    margin: 0 auto:
     img{
        width: 100%;
        height: 100%;
        display: block;
     }
`;

export const GainMoreSliderTitle = styled.h2`
    color: #000000;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 26px;
    width: 100%;
    text-align: center;
    margin: 12px auto 53px;
    position: relative;
    z-index: 3;
`;

export const BoostTrustConfidence = styled.section`
    width: 100%;
    background: #F1FEFF;  
`;

export const BoostTrustConfidenceWrap = styled.div`
    max-width: 996px;
    width: 100%;
    margin: 0 auto;
    padding: 20px;    
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 24px;
    border: 1px solid #000000;
    border-radius: 20px;
    background: #fff;

    @media screen and (max-width: 991px){
        max-width: 100%;
        flex-direction: column;
        align-items: flex-start;
        row-gap: 30px;
        border-radius: 15px;
    }

    @media screen and (max-width: 767px){
        max-width: 100%;
        flex-direction: column;
        row-gap: 40px;
        padding: 15px;
    }
`;

export const BoostTrustConfidenceContent = styled.div`
    max-width: 354px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sand-serif;
    font-weight: 400;
    line-height: 28px;

    @media screen and (max-width: 991px){
        max-width: 100%;
    }
`;

export const BoostTrustConfidenceTitle = styled.h2`
    color: #01606F;
    font-size: 20px;
    font-family: 'Jost', sand-serif;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 15px;

    @media screen and (max-width: 767px){
        font-size: 18px;
        line-height: 26px;
        margin-bottom: 10px;
    }
`;

export const BoostTrustConfidenceText = styled.p`
    padding-bottom: 26px;
    margin-bottom: 0px;

    @media screen and (max-width: 991px){
        padding-bottom: 20px;
    }

    &:last-child{
        padding-bottom: 0px;  
    }
`;

export const BoostTrustConfidenceImages = styled.div`
    max-width: 576px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 20px;

    @media screen and (max-width: 991px){
        max-width: 100%;
        justify-content: flex-start;
    }

    @media screen and (max-width: 480px){
        gap: 20px;
    }

    @media screen and (max-width: 420px){
        flex-direction: column;
    }
`;

export const BoostTrustConfidenceImageList = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    row-gap: 20px;

    @media screen and (max-width: 991px){
        width: calc(33.33% - 8px);
    }
    @media screen and (max-width: 480px){
        width: 100%;
    }

    img{
        width: 100%;
        display: block; 
    }
`;


export const StarBadgeSection = styled.section`
    width: 100%;
    padding: 50px 0px;    
    background: #F1FEFF;

    @media screen and (max-width: 767px){
        padding: 40px 0px;
    }
`;

export const StarBadgeTitle = styled.h2`
    color: #01606F;
    font-size: 20px;
    font-family: 'Jost', sand-serif;
    font-weight: 700;
    line-height: 30px; 
    max-width: 996px;
    margin: 0 auto 10px;
`;

export const StarBadgeWrap = styled.div`
    max-width: 996px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 24px;

    @media screen and (max-width: 991px){ 
        column-gap: 20px;
    }

    @media screen and (max-width: 767px){
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        row-gap: 20px;
    }
`;

export const StarBadgeImage = styled.div`
    max-width: 376px;
    height: 100%;
    // margin: 0 auto;
`;

export const StarBadgeContent = styled.div`
    max-width: 732px;
    background: #FFFFFF;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0px 20px 20px #0000001A;

    @media screen and (max-width: 767px){
        max-width: 100%;
        word-break: break-all;
        border-radius: 15px;
        font-size: 16px;
        line-height: 24px;
        padding: 15px;
    }
`;

export const TopRatedStatus = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;

    @media screen and (max-width: 767px){
        padding-bottom: 40px;
    }

    .top-rated-main{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        @media screen and (max-width: 991px){ 
            flex-direction: column;
            align-items: flex-start;
            row-gap: 50px;
        }

        @media screen and (max-width: 767px){
            row-gap: 40px;
        }

        @media screen and (max-width: 575px){
            row-gap: 20px;
        }
    }
`;

export const TopRatedSlider = styled.div`
    background: #FFFFFF;
    position: relative;
    padding: 10px;
    border-radius: 20px;
    box-shadow: 0px 20px 20px #0000001A;

    .top-rated-slider{
        border: none;
        padding: 10px;
    }

    .swiper-slide{
        position: relative;
        &::before{
            content: '';
            position: absolute;
            width: 100%;
            height: 58px;
            background: transparent linear-gradient(90deg, #FFFFFF00 0%, #FFFFFFD7 39%, #FFFFFFFA 56%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 2;
        }
    }
`;

export const TopRatedStatusContent = styled.div`
    width: 100%;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;

    @media screen and (max-width: 575px){ 
        font-size: 16px;
        line-height: 24px;
    }

    .learn-more-btn{
        color: #fff;
        border: none;
        padding: 12px 32px;
        background: #01606F;
        margin-top: 22px;
        font-size: 16px;
        font-family: 'Jost', sans-serif;
        font-weight: 500;
        line-height: 22px;
        box-shadow: 0px 5px 20px #0000001A;
        transition: 0.2s all ease-in-out;

        @media screen and (max-width: 991px){ 
            margin-top: 0px;
        }

        &:hover{
            background: #FFD495;
            color: #333333;
        }
    }
`;

export const TopRatedStatusTitle = styled.h2`
    color: #01606F;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 15px;

    @media screen and (max-width: 767px){ 
        font-size: 18px;
        line-height: 26px;
    }
`;

export const TopRatedStatusText = styled.p`
    padding-bottom: 20px;
    margin: 0px;

    @media screen and (max-width: 991px){ 
        padding-bottom: 15px;
    }
`;